export const REF_CODE_SEARCH_PARAM = "ref" as const;

export function refLink(url: string, refCode: string): string {
  const u = new URL(url);
  u.searchParams.append(REF_CODE_SEARCH_PARAM, refCode);
  return u.toString();
}
